import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "Realized Gain & Loss";
const description = `The Inventory Summary report serves as a fundamental operational and financial tool, providing a current, detailed snapshot of all physical stock a business holds. It typically lists every product, its current quantity on hand, the associated unit cost , and the resultant total inventory valuation—which is vital for the balance sheet. Furthermore, sophisticated inventory systems enable users to filter the report by specific criteria, most notably by warehouse or location, allowing management to perform accurate, localized stock counts, manage distribution logistics, and reconcile inventory value across the entire enterprise.`;

const images = [
    '/images/reports/purchase-by-supplier/purchase-by-supplier.png', // 0
];


const RealizedGainLoss: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RealizedGainLoss;
